export function convertToUTCTime(localTime: string): string {
  console.log("localTime", localTime);
  const timezoneOffset = new Date().getTimezoneOffset(); // Get timezone offset in minutes

  // Parse the input 'HH:mm' time
  const [hours, minutes] = localTime.split(":").map(Number);

  // Create a Date object for the current day
  const now = new Date();
  now.setHours(hours, minutes, 0, 0);

  // Adjust the time by the timezone offset
  const utcTime = new Date(now.getTime() + timezoneOffset * 60 * 1000);

  // Format the result based on the adjusted utcTime
  const adjustedHours = utcTime.getHours().toString().padStart(2, "0"); // Correct method: getHours()
  const adjustedMinutes = utcTime.getMinutes().toString().padStart(2, "0"); // Correct method: getMinutes()

  console.log(`utc time: ${adjustedHours}:${adjustedMinutes}`);
  return `${adjustedHours}:${adjustedMinutes}`;
}

export function minutesToHHmm(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  // Pad with leading zeros if needed
  const hoursString = hours.toString().padStart(2, "0");
  const minutesString = remainingMinutes.toString().padStart(2, "0");

  return `${hoursString}:${minutesString}`;
}
